import React from 'react';
import { Navigate } from 'react-router-dom';
import { ROUTES } from './common/constants';

function PublicRoutes({ user, children }) {
  if (user) {
    return <Navigate to={ROUTES.MAIN} replace />;
  }

  return children;
}

export default PublicRoutes;
